<span>
    <div class="loader-container" [ngClass]="{ 'fade-out-fast': !loader && activeLoaders <= 0 }">
        <div class="loader">
            <span [ngClass]="{ 'fade-out-fast': !showImageLoader }" class="c-loader"></span>
        </div>
    </div>
    <div id="loaderMessage" [ngClass]="{ 'fade-out-fast': !loader && activeLoaders <= 0 }">
        <div class="child">
            @if (loaderMessage != '') {
                <p>
                    {{ this.loaderMessage }}
                    <span class="chrome" id="wait">.</span>
                </p>
            }
            @if (loaderMessage == '') {
                <p>{{ this.loaderMessageOptional }}</p>
            }
        </div>
    </div>
</span>
